import React from 'react'
import PropTypes from 'prop-types'
import {
    ListView,
    WhiteSpace,
    NavBar,
    Icon,
    SearchBar,
    Card,
    Button,
    SegmentedControl,
    Checkbox,
    Tabs,
    Toast
} from 'antd-mobile'
import 'antd-mobile/dist/antd-mobile.css'
import {Link} from 'react-router-dom'
import {postRequest, getUserInfo} from '../../../utils/utils'
import BottomTab from '../../components/bottomTab'
import './index.css'

import {createForm} from 'rc-form'

//图片引入

import Photo from '../../../images/icons/photo.png'

const CheckboxItem = Checkbox.CheckboxItem
const tabs2 = [
    {title: '申请列表', sub: '1'},
    {title: '审批列表', sub: '2'}
];
const dataSource = new ListView.DataSource({  //这个dataSource有cloneWithRows方法
    rowHasChanged: (row1, row2) => row1 !== row2,
})

class XiaoJiaList extends React.Component {
    static propTypes = {
        getXiaoJia: PropTypes.func.isRequired,
        getXiaoJiaChecklist: PropTypes.func.isRequired,
        deleteXiaoJia: PropTypes.func.isRequired
    }
    state = {
        height: document.documentElement.clientHeight-70,
        dataSource,
        hasdata: true,
        hascheckdata: true,
        tabindex: 1,  //tab选项卡索引判断是申请还是审核列表(1:申请列表；2：审核列表)
        page_size: 1,
        hasMore: true,
        page_size2: 1,
        hasMore2: true,
        isLarge: false,  //是否放大
        imgurl: '' //放大图片地址
    }

    componentWillMount() {
        // const index = this.props.location.state
        // if (index == undefined) {
        //     this.setState({tabindex: 0})
        // }
        // else {
        //     this.setState({tabindex: 1})
        // }
    }

    //完成挂载
    componentDidMount() {
        // const index = this.props.location.state
        // if (index == undefined) {
        //     this.props.getWaiChuBack();
        // }
        // else {
        //     this.props.getWaiChuBackChecklist()
        // }
        this.props.getXiaoJiaChecklist()
    }

    //删除补卡
    delete = async (bukaid) => {
        const {history, deleteXiaoJia} = this.props
        let body = `id=${bukaid}`
        deleteXiaoJia(body, history);
    }
    //滚动分页
    onEndReached1 = () => {
        const {page_size} = this.state
        const pagesize = Math.ceil(this.props.count / 20) //页数
        let p = page_size;
        if (!this.state.hasMore) {
            return
        }
        else {
            if (p >= pagesize) {
                this.setState({hasMore: false})
            }
            else {
                this.setState({hasMore: true})
                p = page_size + 1;
                this.setState({page_size: p})
                const oldData = this.props.listdata;
                this.props.getXiaoJia(p, oldData)
            }
        }
    }
    onEndReached2 = () => {
        const {page_size2, hasMore2} = this.state
        const pagesize = Math.ceil(this.props.count2 / 20) //页数
        let p = page_size2;
        if (!hasMore2) {
            return
        }
        else {
            if (p >= pagesize) {
                this.setState({hasMore2: false})
            }
            else {
                this.setState({hasMore2: true})
                p = page_size2 + 1;
                this.setState({page_size2: p})
                const oldData = this.props.checklistdata;
                this.props.getXiaoJiaChecklist(p, oldData)
            }
        }
    }

    render() {
        const {listdata, hasdata, hascheckdata, checklistdata} = this.props;
        //console.log(hasdata);
        const user = JSON.parse(localStorage.getItem('daka_user'))
        const uid = user.uid;
        //console.log(user);
        const separator = (sectionID, rowID) => (
            <div
                key={`${sectionID}-${rowID}`}
                style={{
                    backgroundColor: '#F5F5F9',
                    height: 10,
                }}
            />
        );
        const nodata = () => {
            return (
                <div className='nodata'>
                </div>
            );
        }
        const row = (rowData, sectionID, rowID) => {
            //console.log(rowData);
            let stateSpan = ""
            if (rowData.status === 0||rowData.status === 3) {
                stateSpan = <span style={{fontSize: 16, color: '#FF8E2B'}}>待{rowData.check_name}审核</span>
            }
            if (rowData.status === 1) {
                stateSpan = <span style={{fontSize: 16, color: '#1296db'}}>已通过</span>
            }
            if (rowData.status === 2) {
                stateSpan = <span style={{fontSize: 16, color: '#ff4d4f'}}>未通过</span>
            }
            // if (rowData.status === 3) {
            //     stateSpan = <span style={{fontSize: 16, color: '#FF8E2B'}}>待领导审核</span>
            // }
            return (
                <Card>
                    <Card.Header
                        extra={stateSpan}
                        title={`申请人: ${rowData.user_id}`}
                        style={{
                            fontSize: 15
                        }}
                    />

                    <Card.Body style={{padding: 10, paddingLeft: 15, display: 'flex', flexDirection: 'row'}}
                              >
                        <div className='list_txcontent'>

                            <div onClick={() => {
                                localStorage.setItem('xiaojia_id', rowData.id)
                                this.state.tabindex == 0 ?
                                    this.props.history.push({pathname: '/xiaojia/detail'}) :
                                    this.props.history.push({pathname: '/xiaojia/check'})
                            }} style={{flex: 1}}>
                                <div className='card-body-list'>{`开始时间： ${rowData.qj_start}`}</div>
                                <div className='card-body-list'>{`结束时间： ${rowData.qj_end}`}</div>
                                <div className='card-body-list'>{`销假时间： ${rowData.endtime}`}</div>
                                <div className='card-body-list'>{`提前销假原由： ${rowData.content}`}</div>
                            </div>
                        </div>
                    </Card.Body>
                    {
                        rowData.status === 0 && this.state.tabindex == 0 ?
                            <Card.Footer className='list_footer' content={<div onClick={() => {
                                localStorage.setItem('waichu_id', rowData.id);
                                this.props.history.push({pathname: '/waichuback/editor'})
                            }}>编辑</div>}
                                         extra={<div onClick={() => {
                                             this.delete(rowData.id)
                                         }}>删除</div>}>
                            </Card.Footer> : ''
                    }
                </Card>

            );
        };

        return (
            <div id='wipeout-list' style={{backgroundColor: '#f5f5f9'}}>
                <NavBar
                    mode="dark"
                    icon={<Icon type="left"/>}
                    onLeftClick={() => this.props.history.goBack()}
                    // rightContent={
                    //     <Link to='/waichu/editor' onClick={() => {
                    //         localStorage.setItem('waichu_id', '');
                    //     }} style={{color: '#fff', paddingTop: 3}}><Icon key="0" type="plus" size='xs'/></Link>
                    // }
                >提前销假审核列表</NavBar>
                <div>
                    <ListView
                        ref={el => this.lv = el}
                        dataSource={this.state.dataSource.cloneWithRows(checklistdata)}
                        renderRow={row}
                        style={{
                            height: this.state.height,
                            overflow: 'auto',
                        }}
                        renderSeparator={separator}
                        renderBodyComponent={!hascheckdata ? nodata : null} //无数据时显示
                        onEndReached={this.onEndReached2}
                        onEndReachedThreshold={10}
                        renderFooter={() => (
                            <p>{hascheckdata ? (this.state.hasMore2 && checklistdata.length >= 20 ? '加载中..., 请稍等' : '已经全部加载完毕') : ''}</p>
                        )}
                    />

                </div>

                {this.state.isLarge ?
                    <div onClick={() => {
                        const large = this.state.isLarge;
                        this.setState({isLarge: !large})
                    }} className='img_view'>
                        <img src={this.state.imgurl}/>
                    </div> : ''
                }
                <div style={{height: 55}}></div>
                <BottomTab selectedTab='buka'/>
            </div>
        )
    }
}

export default XiaoJiaList

